import api from "./api";

/**
 * Raporlama uçları (backend: /api/reports). Yanıtlar ApiResponse zarfında
 * (res.data.data).
 * - summary: MANAGER'ın kendi salonu için dönemsel rapor (Gold'da detaylı).
 * - platform: ADMIN yönetici paneli özeti.
 */
export const reportService = {
  summary: (from, to) => api.get("/reports/summary", { params: { from, to } }),
  platform: () => api.get("/reports/platform"),
  getEmailSettings: () => api.get("/reports/email-settings"),
  updateEmailSettings: (payload) => api.put("/reports/email-settings", payload),
};
